import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import Logo from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "@/lib/api";

export default function FooterSection({ onOpenQuote }) {
  const year = new Date().getFullYear();
  return (
    <footer id="contact" className="scroll-mt-16 border-t border-white/10 bg-hydro-navy pb-32 pt-24 md:pb-16 md:pt-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-hydro-cyan sm:text-xs">
            Contact
          </p>
          <h2 className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-5xl md:text-7xl">
            Apă din propriul puț, la un telefon distanță.
          </h2>
          <a
            href={PHONE_TEL}
            data-testid="footer-phone-link"
            className="mt-10 inline-block font-display text-4xl font-black tracking-tight text-hydro-cyan transition-colors hover:text-white sm:text-5xl md:text-8xl"
          >
            {PHONE_DISPLAY}
          </a>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              type="button"
              data-testid="footer-quote-button"
              onClick={() => onOpenQuote()}
              className="rounded-full bg-hydro-cyan px-7 py-4 text-base font-bold text-hydro-navy transition-colors hover:bg-white"
            >
              Trimite o cerere
            </button>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-button"
              className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-4 text-base font-bold text-white transition-colors hover:border-hydro-cyan hover:text-hydro-cyan"
            >
              <MessageCircle size={17} />
              Scrie pe WhatsApp
            </a>
          </div>
        </motion.div>

        <div className="mt-20 flex flex-wrap items-center justify-between gap-6 border-t border-white/10 pt-8">
          <Logo />
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="text-xs text-white/30 transition-colors hover:text-white/70"
          >
            Panou administrare
          </a>
          <p className="text-xs text-white/40">
            © {year} Puțul tău — Foraje puțuri București &amp; Ilfov · Foraje · Denisipări · Pompe
          </p>
        </div>
      </div>
    </footer>
  );
}
